module.exports = __webpack_public_path__ + "img/Retail10.9e594588.png";